import { render, staticRenderFns } from "./blocStarList.vue?vue&type=template&id=021a5966&scoped=true"
import script from "./blocStarList.vue?vue&type=script&lang=js"
export * from "./blocStarList.vue?vue&type=script&lang=js"
import style0 from "./blocStarList.vue?vue&type=style&index=0&id=021a5966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a5966",
  null
  
)

export default component.exports